import ar from './ar.json';
import az from './az.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import hy from './hy.json';
import ja from './ja.json';
import ka from './ka.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import tr from './tr.json';
import zh from './zh.json';

export const LanguageCodes = {
	ar,
	az,
	de,
	en,
	es,
	fr,
	hy,
	ja,
	ka,
	ko,
	pt,
	ru,
	tr,
	zh
};
